export const ON_LOAD_CHANNEL = 'ON_LOAD_CHANNEL'
export const ON_VERIFY_OAUTH = 'ON_VERIFY_OAUTH'
export const ON_VERIFY_OAUTH_SUCCESS = 'ON_VERIFY_OAUTH_SUCCESS'
export const ON_VERIFY_OAUTH_FAILURE = 'ON_VERIFY_OAUTH_FAILURE'
export const ON_OK_OAUTH = 'ON_OK_OAUTH'

export const onLoadChannel = payload => ({
    type: 'ON_LOAD_CHANNEL',
    payload,
})

export const onVerifyOAuth = payload => ({
    type: 'ON_VERIFY_OAUTH',
    payload,
})

export const onVerifyOAuthSuccess = payload => ({
    type: 'ON_VERIFY_OAUTH_SUCCESS',
    payload
})

export const onVerifyOAuthFailure = payload => ({
    type: 'ON_VERIFY_OAUTH_FAILURE',
    payload,
})

export const onOk = payload => ({
    type: 'ON_OK_OAUTH',
    payload,
})



// WEBPACK FOOTER //
// ./src/actions/settingOAuthAction.js